import { combineReducers } from 'redux';
import updateSocketConnection from './socketConnection';
const reducers = combineReducers({
    updateSocketConnection: updateSocketConnection,
})
export default reducers